import React from 'react';

const TermsOfService = () => {
  return (
    <section className="bg-white py-16">
      <div className="mx-auto max-w-4xl space-y-8 px-6">
        <h1 className="text-3xl font-bold text-slate-900">Terms of Service</h1>
        <p className="text-slate-600">
          These Terms of Service explain how Dial TPR coordinates calls, shop confirmations, and last
          mile delivery on your behalf. By placing an order or partnering with us you agree to the
          terms listed below.
        </p>
        <div className="space-y-4">
          <div>
            <h2 className="text-xl font-semibold text-slate-900">Our service</h2>
            <p className="text-slate-600">
              Dial TPR acts as your call-first concierge. We collect your requirements, confirm product
              availability with local shops, and arrange delivery through our trained executives. Shop
              invoices are shared with every delivery. Product pricing and taxes are determined solely
              by the respective store.
            </p>
          </div>
          <div>
            <h2 className="text-xl font-semibold text-slate-900">Payments and invoices</h2>
            <p className="text-slate-600">
              Customers settle invoices directly with Dial TPR or the partner shop depending on the
              arrangement made during the call. Service fees, if applicable, are communicated upfront
              before dispatching the delivery executive. A digital or printed invoice accompanies every
              completed order.
            </p>
          </div>
          <div>
            <h2 className="text-xl font-semibold text-slate-900">Cancellations and returns</h2>
            <p className="text-slate-600">
              You can modify or cancel an order before the shop confirms packaging. Once packed, any
              cancellations or returns must follow the respective store&apos;s policies. Our team assists in
              communicating these requests but cannot override partner store decisions.
            </p>
          </div>
          <div>
            <h2 className="text-xl font-semibold text-slate-900">Partner responsibilities</h2>
            <p className="text-slate-600">
              Retail partners must provide accurate pricing, GST-compliant invoices, and packaged goods
              that meet customer expectations. Delivery executives handle pickup and drop-off, but
              product quality, warranties, and replacements remain the responsibility of the selling
              store.
            </p>
          </div>
          <div>
            <h2 className="text-xl font-semibold text-slate-900">Liability</h2>
            <p className="text-slate-600">
              Dial TPR is responsible for coordinating the delivery process with care. However, we are
              not liable for delays caused by extreme weather, traffic restrictions, or issues arising
              from inaccurate information shared by customers or partner stores.
            </p>
          </div>
          <div>
            <h2 className="text-xl font-semibold text-slate-900">Contact</h2>
            <p className="text-slate-600">
              For clarifications about these terms please contact our operations desk at{' '}
              <a className="text-emerald-600" href="tel:+919629128356">
                +91 96291 28356
              </a>{' '}
              or email{' '}
              <a className="text-emerald-600" href="mailto:dailtpr@gmail.com">
                dailtpr@gmail.com
              </a>
              .
            </p>
          </div>
        </div>
        <p className="text-sm text-slate-500">Last updated: {new Date().toLocaleDateString()}</p>
      </div>
    </section>
  );
};

export default TermsOfService;
